interface PdfAttachmentParams {
  pdfBlob: Blob;
  formNumber: string | undefined;
  formTitle: string;
}

interface EmailAttachment {
  filename: string;
  content: string;
  contentType: string;
}

/**
 * Creates a PDF email attachment from a blob
 * @param pdfBlob - PDF blob to convert
 * @param formNumber - Form number for filename
 * @param formTitle - Form title for filename
 * @returns Email attachment object with base64 content
 */
export const createPdfAttachment = async ({
  pdfBlob,
  formNumber,
  formTitle
}: PdfAttachmentParams): Promise<EmailAttachment> => {
  const base64pdf = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(pdfBlob);
  });

  return {
    filename: `${formNumber}-${formTitle}.pdf`,
    content: base64pdf.split('base64,')[1],
    contentType: 'application/pdf'
  };
};

